import { useMemo } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { COMMENT_MAX_LENGTH } from 'src/config/form-validation-rules';
import { ChargePointFormModel } from 'src/core/model/charge-point.model';
import { useFormValidation } from 'src/shared/form/use-form-validation';
import { CreateChargePointModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/shared/src/cpo-service/charge-point/models/create-charge-point.model';

export type ChargePointFormValidation = {
  cpoId: RegisterOptions<ChargePointFormModel, 'cpoId'>;
  locationId: RegisterOptions<ChargePointFormModel, 'locationId'>;
  evseUid: RegisterOptions<ChargePointFormModel, 'evseUid'>;
  connectorId: RegisterOptions<ChargePointFormModel, 'connectorId'>;
  comment: RegisterOptions<ChargePointFormModel, 'comment'>;
  themeId: RegisterOptions<ChargePointFormModel, 'themeId'>;
  mustGenerateQrCode: RegisterOptions<
    ChargePointFormModel,
    'mustGenerateQrCode'
  >;
  qrCodeIdentifier: RegisterOptions<ChargePointFormModel, 'qrCodeIdentifier'>;
};

export function useChargePointFormValidation(): ChargePointFormValidation {
  const { t } = useTranslation();

  const chargePointTranslations: Record<keyof CreateChargePointModel, string> =
    t('model.charge-point', {
      returnObjects: true,
    });

  const formValidationRules = useFormValidation();

  return useMemo(
    () => ({
      cpoId: {
        ...formValidationRules.required({
          field: chargePointTranslations.cpoId,
        }),
      },
      locationId: {
        ...formValidationRules.required({
          field: chargePointTranslations.locationId,
        }),
      },
      evseUid: {
        ...formValidationRules.required({
          field: chargePointTranslations.evseUid,
        }),
      },
      connectorId: {},
      comment: {
        ...formValidationRules.maxLength({
          field: chargePointTranslations.comment,
          value: COMMENT_MAX_LENGTH,
        }),
      },
      themeId: {
        ...formValidationRules.uidPattern({
          field: chargePointTranslations.themeId,
        }),
      },
      mustGenerateQrCode: {},
      qrCodeIdentifier: {},
    }),
    [formValidationRules, chargePointTranslations],
  );
}
